import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { useTranslation } from "react-i18next";
import Tab from "apollo-react/components/Tab";
import Tabs from "apollo-react/components/Tabs";
import Badge from "apollo-react/components/Badge";
import ReviewsListCards from "../../../common/Reviews_Cards/list";
import DraftsList from "../Drafts/DraftsList";

const MyRequests = () => {
  const [t] = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeRequestsProgress, setActiveRequestsProgress] = useState([]);
  const [submittedRequestsProgress, setSubmittedRequestsProgress] = useState([]);
  const [approvedRequestsProgress, setApprovedRequestsProgress] = useState([]);
  const [rejectedRequestsProgress, setRejectedRequestsProgress] = useState([]);
  const [drafts, setDrafts] = useState([]);

  const [activeTab, setActiveTab] = useState(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get('tab');
    if (tabFromUrl !== null) {
      return parseInt(tabFromUrl, 10);
    }
    const storedTab = localStorage.getItem("customer_requests_activeTab");
    return storedTab !== null ? parseInt(storedTab, 10) : 0;
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get('tab');
    if (tabFromUrl !== null) {
      const tabIndex = parseInt(tabFromUrl, 10);
      setActiveTab(tabIndex);
      localStorage.setItem("customer_requests_activeTab", tabIndex);
      navigate('/customer/requests/my-requests', { replace: true });
    } else {
      const storedTab = localStorage.getItem("customer_requests_activeTab");
      const tabIndex = storedTab !== null ? parseInt(storedTab, 10) : 0;
      setActiveTab(tabIndex);
    }
  }, [location.search, navigate]);

  const fetchMyRequests = async () => {
    const response = await axiosInstance
      .get("/api/requests-progress/user/requests", {});
    setActiveRequestsProgress(response?.data.activeRequestsProgress || []);
    setSubmittedRequestsProgress(response?.data.submittedRequestsProgress || []);
    setApprovedRequestsProgress(response?.data.approvedRequestsProgress || []);
    setRejectedRequestsProgress(response?.data.rejectedRequestsProgress || []);
  };
  useEffect(() => {
    fetchMyRequests();
  }, []);

  const handleComplete = async () => {
    // Re-fetch all data after completion
    await fetchMyRequests();
  };

  const handleChangeTab = (event, value) => {
    setActiveTab(value);
    localStorage.setItem("customer_requests_activeTab", value);
  };

  const getCurrentData = () => {
    switch (activeTab) {
      case 0:
        return activeRequestsProgress; // Assigned
      case 1:
        return submittedRequestsProgress; // Submitted
      case 2:
        return approvedRequestsProgress; // Approved
      case 3:
        return rejectedRequestsProgress; // Rejected
      case 4:
        return drafts; // Drafts
      default:
        return activeRequestsProgress;
    }
  };

  const handleDraftsChange = (updatedDrafts) => {
    setDrafts(updatedDrafts);
  };

    return (
      <div>
        <Tabs
          value={activeTab}
          onChange={handleChangeTab}
          truncate
          style={{ marginBottom: "30px" }}
          shape="box"
        >
          <Tab
            label={
              <>
                {t("Assigned")}
                <Badge badgeContent={activeRequestsProgress?.length} />
              </>
            }
          />
          <Tab
            label={
              <>
                {t("Under Review")}
                <Badge badgeContent={submittedRequestsProgress?.length} />
              </>
            }
          />
          <Tab
            label={
              <>
                {t("Approved")}
                <Badge badgeContent={approvedRequestsProgress?.length} />
              </>
            }
          />
          <Tab
            label={
              <>
                {t("Rejected")}
                <Badge badgeContent={rejectedRequestsProgress?.length} />
              </>
            }
          />
          <Tab
            label={
              <>
                {t("Drafts")}
                <Badge badgeContent={drafts?.length} />
              </>
            }
          />
        </Tabs>

         {activeTab === 4 ? (
          <DraftsList onDraftsChange={handleDraftsChange} />
         ) : (
          <ReviewsListCards 
            requestsProgresses={getCurrentData()} 
            route={`/customer/requests/my-requests`}
            onComplete={handleComplete}
            persona={"customer"}
            currentTab={activeTab}
          />
         )}
      </div>
    );
  };

export default MyRequests;